// extracted by mini-css-extract-plugin
export default {"parentdiv":"ProductCategories_parentdiv__J5ntZ","divCarrousell":"ProductCategories_divCarrousell__bx+GP"};